// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2yh51","label":"CategoryService_label__3iLPn","location":"CategoryService_location__21KJl"};